<template>
    <div class="phi-post-filters">
        <div class="search" >
            <mu-icon value="search"></mu-icon>
            <phi-input :label="$t('search')" v-model="value.q" @input="input()"></phi-input>
        </div>

        <div class="filters">
            <div>
                <select v-model="value.type" @change="change()">
                    <option :value="null" v-text="$t('noun.all.plural')"></option>
                    <option v-for="type in types"
                        :key="type.id"
                        :value="type.singular"
                        v-text="type.plural"
                    ></option>
                </select>
            </div>

            <div>
                <label v-text="$t('prep.until')"></label>
                <input type="date" v-model="value.creationDate" @input="change()" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "phi-post-filters",

    props: {
        value: {
            type: Object,
            required: true
        },

        types: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            changeTimeout: null
        }
    },

    methods: {
        input() {
            this.$emit('input', this.value);

			clearTimeout(this.changeTimeout);
			this.changeTimeout = setTimeout(this.change, 500);
        },

        change() {
            this.$emit("change", this.value);
        }
    }
}
</script>

<style lang="scss">
.phi-post-filters {
    .search {
        display: flex;
        align-items: center;

        .mu-icon {
            color: #777;
            margin-right: .4em;
            font-size: 22px;
        }

        .phi-input {
            flex: 1;
        }

        .phi-input input {
            font-size: 1em;
        }
    }

}
</style>
